export function sanitizeStringForFileSafeName(value: string) {
  return value
    .replace(/[/\\:*?"<>|]/g, '') // remove unsafe characters
    .replace(/[\s]+/g, '_') // replace spaces with underscores
    .replace(/[^\w.-]/g, '') // remove any remaining unsafe characters
    .replace(/_+/g, '_') // collapse multiple underscores
    .replace(/^_+|_+$/g, '') // trim leading/trailing underscores
}
